
export const en = {
  auth: {
    login: "Sign in",
    startFreeTrial: "Start free trial",
    register: "Register",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    errorDescription: "An error occurred",
    errorTitle: "Error",
    successTitle: "Success",
    successDescription: "Operation successful",
    continueWithGoogle: "Continue with Google",
    createAccount: "Create account",
    trialDescription: "Start with a 14-day free trial",
    emailPlaceholder: "your@email.com",
    creating: "Creating...",
    create: "Create",
    errorMessage: "An error occurred"
  },
  navigation: {
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
    themes: "Themes",
    resources: "Resources",
    home: "Home",
    dashboard: "Dashboard",
    products: "Products",
    orders: "Orders",
    customers: "Customers",
    settings: "Settings"
  },
  footer: {
    acceptedPayments: "Accepted payments",
    allRightsReserved: "All rights reserved",
    quickLinks: "Quick links",
    legalNotice: "Legal notice",
    accessibility: "Accessibility",
    termsOfUse: "Terms of use",
    support: "Support",
    followUs: "Follow us",
    socialMedia: "Find us on social media",
    newsletter: "Newsletter",
    subscribeNewsletter: "Subscribe to our newsletter",
    emailPlaceholder: "Your email",
    subscribe: "Subscribe",
    changeLanguage: "Change language"
  },
  pricing: {
    title: "Plans and pricing",
    subtitle: "Choose the plan that fits your needs",
    startTrial: "Start free trial",
    mostPopular: "Most popular",
    freeTrial: "14-day free trial",
    perMonth: "/month",
    basic: {
      name: "Basic",
      price: "11",
      description: "To get started",
      features: [
        "1 store",
        "100 products",
        "Email support"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "For professionals",
      features: [
        "3 stores",
        "1000 products",
        "Priority support",
        "Advanced analytics"
      ]
    },
    enterprise: {
      name: "Enterprise",
      price: "97",
      description: "For large companies",
      features: [
        "Unlimited stores",
        "Unlimited products",
        "Dedicated support",
        "Custom API"
      ]
    }
  },
  profile: {
    title: "My Profile",
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    update: "Update",
    updating: "Updating...",
    success: "Profile updated successfully",
    error: "Error updating profile"
  },
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    actions: "Actions",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    close: "Close"
  }
};
